import React, { useEffect, useRef } from 'react';
import { useMembers } from '../../../context/membersContext.tsx';
import Member from './Member.tsx';
import { sortMembers } from '../../../data.js';
import gsap from 'gsap';

interface MembersProps {
  department?: string;
  onCountChange?: (count: number) => void;
}

const Members = ({ department, onCountChange }: MembersProps) => {
  const { members, loading } = useMembers();
  const gridRef = useRef<HTMLUListElement>(null);

  const filteredMembers = sortMembers(members, department);

  useEffect(() => {
    if (onCountChange) {
      onCountChange(filteredMembers.length);
    }
  }, [filteredMembers.length, onCountChange]);

  useEffect(() => {
    if (gridRef.current) {
      const cards = gridRef.current.querySelectorAll('.member-card');
      gsap.fromTo(cards,
        { y: 30, opacity: 0, scale: 0.95 },
        { y: 0, opacity: 1, scale: 1, duration: 0.4, stagger: 0.05, ease: 'power2.out' }
      );
    }
  }, [filteredMembers, department]);

  if (loading) {
    return (
      <div className="flex items-center justify-center py-20">
        <div className="w-8 h-8 border-2 border-mainBlue border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <div className="w-full">
      <ul
        ref={gridRef}
        className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4 md:gap-5"
      >
        {filteredMembers.map((member: any, index: number) => (
          <li key={index} className="member-card">
            <Member
              photo={member.photoURL}
              photoWithoutBackground={member.photoWithoutBackgroundURL}
              name={member.name}
              role={member.role}
              linkedin={member.linkedin}
              years={member.years}
            />
          </li>
        ))}
      </ul>
      {filteredMembers.length === 0 && (
        <div className="text-center py-16">
          <p className="text-gray-400 text-lg font-custom">No members found for this department.</p>
        </div>
      )}
    </div>
  );
};

export default Members;
